(() => {
  if (window.gsnNavigationInitialized) return;
  window.gsnNavigationInitialized = true;
  const families = new Set(['all', 'hoodie', 'zip', 'jogger', 'shirts', 'jackets']);
  const routes = {
    '/collections/all': { family: 'all' },
    '/collections/neu-ss26': { family: 'all' },
    '/collections/t-shirts': { family: 'shirts' },
    '/collections/sweatshirts': { family: 'zip', from: 'Sweatshirts', to: 'Zipper' },
    '/collections/hemden': { family: 'jackets', from: 'Hemden', to: 'Jacken' },
    '/collections/hosen': { family: 'jogger' }
  };
  const labels = {
    '/search': { from: 'Search', to: 'Suchen' },
    '/pages/about-us': { from: 'About Us', to: 'Über uns' },
    '/policies/privacy-policy': { from: 'Privacy Policy', to: 'Datenschutz' }
  };
  function rewrite(anchor) {
    if (!anchor?.matches?.('a[href]')) return;
    if (anchor.closest('.gs-breadcrumbs')) return;
    if (anchor.getAttribute('href')?.trim().startsWith('#')) return;
    let url;
    try { url = new URL(anchor.getAttribute('href'), location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    const rawPath = url.pathname.replace(/\/+$/, '');
    const localePrefix = rawPath.match(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/(?:collections|pages|policies|search)(?:\/|$))/i)?.[0] || '';
    const path = rawPath.slice(localePrefix.length);
    const route = routes[path];
    if (!route && !labels[path]) return;
    if (route) {
    // Keep already scoped links (category index, hero, previously rewritten menus) intact.
    const requested = url.searchParams.get('family');
    const query = url.searchParams.get('q');
    const family = path === '/collections/all' && url.searchParams.get('view') === 'gs-night' && families.has(requested)
      ? requested : route.family;
    url.pathname = localePrefix + '/collections/all';
    url.search = '';
    url.searchParams.set('view', 'gs-night');
    url.searchParams.set('family', family);
    if (query?.trim()) url.searchParams.set('q', query.trim());
    const target = url.pathname + url.search + url.hash;
    if (anchor.getAttribute('href') !== target) anchor.setAttribute('href', target);
    }
    const labelRule = route?.from ? route : labels[path];
    if (!labelRule) return;
    const walker = document.createTreeWalker(anchor, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('svg,script,style')) continue;
      const label = node.nodeValue.trim();
      if (label.toLowerCase() !== labelRule.from.toLowerCase()) continue;
      const replacement = label === label.toUpperCase() ? labelRule.to.toUpperCase() : labelRule.to;
      node.nodeValue = node.nodeValue.replace(label, replacement);
    }
  }
  function scan(scope) {
    rewrite(scope);
    scope.querySelectorAll?.('a[href]').forEach(rewrite);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') rewrite(record.target);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  document.addEventListener('click', event => rewrite(event.target.closest?.('a[href]')), true);
})();
